import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {URL} from '../../constants/urls.constants'
import {Token} from '../token/index';
import { Router } from '@angular/router';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  isProfileLoaded = false;
  public $profile: BehaviorSubject<any> = new BehaviorSubject(null);
  readonly changes = this.$profile.asObservable();
  profileData: any;
  constructor(
    private $http: HttpClient,
    private $token: Token,
    private $router: Router
  ) { }
  queryProfile(): Observable<void> {
    return new Observable((observer: Observer<void>) => {
      if (this.$token.hasValue) {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.$token.value}`);
        this.$http.get<Api.Response<any>>(URL.adminProfile, { headers }).subscribe((resp) => {
          this.isProfileLoaded = true;
          this.$profile.next(resp.data);
          // this.$router.navigateByUrl(LAYOUT_ROUTE.url);
          observer.next(resp.data);
          observer.complete();
        }, () => {
          this.isProfileLoaded = true;
          observer.next(null);
          observer.complete();
        });
      } else {
        this.next(null);
        this.isProfileLoaded = true;
        observer.next(this.$profile.getValue());
      }
    });
  }
  next(value) {
    this.$profile.next(value);
  }
  logout() {
    this.$http.post(URL.logout,{}).subscribe(data=>{
      this.next(0);
      localStorage.clear();
      this.$router.navigateByUrl(PUBLIC_ROUTE.url);
      // window.location.reload();
    })
  }
  listenChanges() {
    this.changes.subscribe(
      data => {
        this.profileData = data;
      }
    )
  }
}
